import React from "react";
import BubbleTip from "../../../assets/svg/bubbleTip.svg";
import { purifiedParsedString } from "../../utilities";

export default function Testimony({ data, classes, offset }) {
  if (!data) {
    return null;
  }

  return (
    <div
      className={`testimonials-testimony ${classes ? classes.join(" ") : ""}`}
      {...(offset !== undefined && { style: { "--offset": offset } })}
    >
      <div className="testimonials-testimony-quote">
        <div>{purifiedParsedString(data.quote)}</div>
      </div>
      <div className="testimonials-testimony-container">
        <div className="testimonials-testimony-name">{`${data.source.name},`}</div>
        <div className="testimonials-testimony-description">{data.source.description}</div>
        <BubbleTip className="testimonials-testimony-tip" />
      </div>
      <div className="testimonials-testimony-location">{data.source.location}</div>
    </div>
  );
}
